import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paginator } from '../models/paginator';
import { DiscoveredUrl, DiscoveredUrlsFilters } from '../models/discoveredUrls';

@Injectable({
  providedIn: 'root'
})
export class DiscoveredUrlsService {

  constructor(
    private http: HttpClient
  ) {
  }

  deleteMany(ids: string[]): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(
        `${environment.backend}/integrations/backlinks`,
        { body: { discoveredUrls: ids } }
      )
    );
  }

  // Leaves discovered pages out of the coming capture, or puts them back.
  setExcluded(integrationId: string, ids: string[], excluded: boolean): Promise<{ modified: number }> {
    return firstValueFrom(
      this.http.patch<{ modified: number }>(
        `${environment.backend}/integrations/backlinks/${integrationId}/exclusion`,
        { discoveredUrls: ids, excluded },
      )
    );
  }

  retrieveBacklinksPaginated(
    integrationId: string,
    pageNumber: number,
    limit: number,
    offset: number,
    sort?: string,
    filters?: DiscoveredUrlsFilters,
  ) {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset);

    if (sort) {
      params = params.set('sort', sort);
    }

    if (filters?.query) {
      params = params.set('query', filters.query);
    }

    if (filters?.depth) {
      params = params.set('depth', filters.depth);
    }

    return firstValueFrom(
      this.http.get<Paginator<DiscoveredUrl>>(
        `${environment.backend}/integrations/backlinks/${integrationId}/search`,
        { params }
      )
    );
  }
}
